import $ from "jquery";

const singleProductTabs = () => {
  const init = () => {
    execute();
  };

  const execute = () => {
    $(function () {
      $(".js-single-product-tabs-content-wrapper .tab-content").hide();

      $(".js-single-product-tabs-wrapper .tab-title").on("click", function () {
        $(".js-single-product-tabs-wrapper .tab-title").removeClass("active");
        $(this).addClass("active");
        $(".js-single-product-tabs-content-wrapper .tab-content").removeClass(
          "active"
        );

        const activeTab = $(this).find("a").attr("href");
        $(activeTab).addClass("active");
        return false;
      });
    });
  };

  init();
};

try {
  singleProductTabs();
} catch (error) {
  console.log(error);
}
